/* Heny Cart Gift Offer — attribute-based.
 * Pairs with snippets/heny-cart-gift-offer.liquid.
 * Gifts are written to cart.attributes (not as line items).
 * Staff sees the chosen gift in the order admin under "Additional details"
 * and in the order confirmation email.
 *
 * Swap is purely client-side (hide DONE, show PICKER open) — no server call
 * until a new variant is picked. This avoids all the line-item-add/remove
 * race conditions that plagued the previous design.
 */
(function () {
  if (window.__henyGiftOfferBound) return;
  window.__henyGiftOfferBound = true;

  var T1_THRESHOLD = 50000;
  var T2_THRESHOLD = 100000;
  var T1_KEY = 'מתנה ראשונה (₪500+)';
  var T2_KEY = 'מתנה (₪1,000+)';
  var LEGACY_KEYS = ['מתנה ראשונה (₪500+)', 'מתנה שנייה (₪1,000+)'];

  function onCartPage() {
    try {
      if (document.body && document.body.classList && document.body.classList.contains('template-cart')) return true;
      if (window.location && window.location.pathname === '/cart') return true;
    } catch (e) {}
    return false;
  }

  function swapSnippet() {
    return fetch('/?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-heny-gift-offer]');
        document.querySelectorAll('[data-heny-gift-offer]').forEach(function (live) {
          if (!fresh) {
            if (live.parentNode) live.parentNode.removeChild(live);
          } else {
            live.outerHTML = fresh.outerHTML;
          }
        });
      })
      .catch(function () {});
  }

  function refreshCart() {
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function cartGet() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function updateAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  /**
   * Auto-clear gift attribute when its threshold is no longer met
   * (e.g. customer removed an item or applied a coupon that dropped subtotal).
   */
  function autoRemoveStaleAttributes() {
    return cartGet().then(function (cart) {
      var newAttrs = {};
      var needsUpdate = false;
      var attrs = cart.attributes || {};
      if (attrs[T1_KEY]) {
        newAttrs[T1_KEY] = '';
        needsUpdate = true;
      }
      LEGACY_KEYS.forEach(function (k) {
        if (attrs[k]) { newAttrs[k] = ''; needsUpdate = true; }
      });
      if (attrs[T2_KEY] && cart.total_price < T2_THRESHOLD) {
        newAttrs[T2_KEY] = '';
        needsUpdate = true;
      }
      if (!needsUpdate) return false;
      return updateAttributes(newAttrs).then(function () { return true; });
    }).catch(function () { return false; });
  }

  /**
   * Backward-compat: if a customer has a legacy gift line item from the old
   * design (handle gift-tier-500 / gift-tier-1000), strip it on page load
   * so they don't ship a ghost line item. The attribute equivalent will be
   * picked fresh from the new picker.
   */
  function removeLegacyGiftLineItems() {
    return cartGet().then(function (cart) {
      var toRemove = [];
      (cart.items || []).forEach(function (item) {
        if (item.handle === 'gift-tier-500' || item.handle === 'gift-tier-1000') {
          toRemove.push(item.key);
        }
      });
      if (toRemove.length === 0) return false;
      var chain = Promise.resolve();
      toRemove.forEach(function (k) {
        chain = chain.then(function () { return changeLine(k, 0); });
      });
      return chain.then(function () { return true; });
    }).catch(function () { return false; });
  }

  /* ===== CLICK HANDLER ===== */
  document.addEventListener('click', function (e) {
    // Open/close the picker options grid
    var toggleBtn = e.target.closest('[data-heny-go-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var picker = toggleBtn.closest('[data-heny-go-picker]');
      if (!picker) return;
      var opts = picker.querySelector('[data-heny-go-opts]');
      if (!opts) return;
      var isOpen = !opts.hasAttribute('hidden');
      if (isOpen) {
        opts.setAttribute('hidden', '');
        picker.classList.remove('heny-go--open');
      } else {
        opts.removeAttribute('hidden');
        picker.classList.add('heny-go--open');
        setTimeout(function () {
          try { opts.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
        }, 60);
      }
      return;
    }

    // Swap — purely client-side: hide DONE, show PICKER open. No server call.
    // Customer picks a new variant → that's the only server call (update attr).
    var swapBtn = e.target.closest('[data-heny-go-swap]');
    if (swapBtn) {
      e.preventDefault();
      var block = swapBtn.closest('[data-heny-go-block]');
      if (!block) return;
      var done = block.querySelector('[data-heny-go-done]');
      var picker = block.querySelector('[data-heny-go-picker]');
      if (done) done.style.display = 'none';
      if (picker) {
        picker.classList.remove('heny-go--initially-hidden');
        picker.style.display = '';
        var opts = picker.querySelector('[data-heny-go-opts]');
        if (opts) {
          opts.removeAttribute('hidden');
          picker.classList.add('heny-go--open');
          setTimeout(function () {
            try { opts.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
          }, 80);
        }
      }
      return;
    }

    // Pick — set the gift attribute, then refresh so snippet renders DONE state.
    var pickBtn = e.target.closest('[data-heny-go-pick]');
    if (pickBtn) {
      e.preventDefault();
      if (pickBtn.disabled) return;
      var title = pickBtn.getAttribute('data-variant-title');
      var tier = parseInt(pickBtn.getAttribute('data-tier'), 10) || 1;
      if (!title) {
        console.error('[heny-go] pick: missing variant title');
        return;
      }
      var pickerEl = pickBtn.closest('.heny-go--picker');
      if (pickerEl) pickerEl.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      pickBtn.style.opacity = '0.6';
      console.log('[heny-go] picking', title, 'tier', tier);
      var attrs = {};
      attrs[tier === 2 ? T2_KEY : T1_KEY] = title;
      updateAttributes(attrs)
        .then(function (r) {
          if (!r.ok) {
            return r.text().then(function (txt) { throw new Error('update failed ' + r.status + ': ' + txt); });
          }
          return r.json();
        })
        .then(function () {
          console.log('[heny-go] attr saved');
          refreshCart();
        })
        .catch(function (err) {
          console.error('[heny-go] update failed', err);
          if (pickerEl) pickerEl.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
          pickBtn.style.opacity = '';
          alert('שגיאה בשמירת הבחירה: ' + (err && err.message ? err.message : 'נסי שוב.'));
        });
      return;
    }
  });

  /* ===== CART REFRESH LISTENERS ===== */
  var debounceTimer = null;
  var inFlight = false;
  function onCartChanged() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (inFlight) return;
      inFlight = true;
      autoRemoveStaleAttributes()
        .then(function (removed) {
          inFlight = false;
          if (removed) {
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));
          }
          return swapSnippet();
        })
        .catch(function () { inFlight = false; });
    }, 150);
  }

  ['eurus:cart:items-changed', 'eurus:cart:add-as-bundle', 'eurus:cart:redirect',
   'cart:refresh', 'cart:change', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, onCartChanged);
  });

  /* ===== INITIAL CHECK on page load ===== */
  document.addEventListener('DOMContentLoaded', function () {
    // Clean up any legacy line-item gifts from the previous design, then
    // run the standard stale-attribute check.
    removeLegacyGiftLineItems()
      .then(function (cleaned) {
        if (cleaned) {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true }));
        }
        return autoRemoveStaleAttributes();
      })
      .then(function () { return swapSnippet(); });
  });
})();
